import React, { ReactElement, useEffect } from 'react';
import { Col, Row } from 'antd';
import { GUTTOR_SPACE, NON_CLASSIFICATION_ERR } from '../../constants/commonConstants';
import { RADIO_SWITCH_OPTION } from '../../constants/crmConstants';
import { FormRadioButton, FormSelect } from '../crmFormElement/FormInput';
import { ReactComponent as DownArrow } from '../../../assets/images/svg/Down_Arrow_File_Selection.svg';
import { FormInstance } from 'antd/lib/form';
import { FileNameOptions } from '../../interfaces/newAdmissionInterface';
interface DescrepencyQuestionProps {
  classification: {
    questionText: string;
    questionType: string;
    isSelectFile: boolean;
  };
  onChangeQuestion: (value: any) => void;
  fileNames: FileNameOptions[];
  setFinalAnswer: (value: any) => void;
  buddhimedForm: FormInstance;
}

const HisDescrepencyQuestion = ({
  classification,
  onChangeQuestion,
  fileNames: options,
  setFinalAnswer,
  buddhimedForm,
}: DescrepencyQuestionProps): ReactElement => {
  const { questionText, questionType, isSelectFile } = classification;

  useEffect((): void => {
    const selectedQuestionType = buddhimedForm.getFieldValue(questionType);
    const isSelectedOptionValid = options?.some((option: FileNameOptions): boolean => option.value === selectedQuestionType);
    if (!isSelectedOptionValid) {
      buddhimedForm.setFieldsValue({ [questionType]: undefined });
    }
  }, [options]);

  return (
    <Row gutter={GUTTOR_SPACE} className="discrepency-questions">
      <Col span={12} className="his-mandatory-questions his-file-selection">
        <FormRadioButton
          detail={{
            key: questionText,
            options: RADIO_SWITCH_OPTION,
            disabled: false,
            rules: [{ required: true, message: NON_CLASSIFICATION_ERR }],
            onChange: onChangeQuestion,
            className: 'discrepency-raido-btn',
          }}
        />
      </Col>
      {isSelectFile && (
        <Col span={10} className="his-file-selection">
          <FormSelect detail={{
            key: questionType,
            label: 'Select File',
            hideLabel: true,
            placeholder: 'Select the relevant document',
            options,
            onChange: setFinalAnswer,
            allowClear: false,
            rules: [{ required: true, message: 'File selection is required.' }],
            className: 'italic-placeholder',
            suffixIcon: <DownArrow />,
          }}
          />
        </Col>
      )}
    </Row>
  );
};

export default HisDescrepencyQuestion;
